import React, {useEffect, useState} from "react";
import AdminH from "../topDownAdmin/adminH";
import {Outlet} from "react-router-dom";
import LiveClock from "./adminContainers/dashboardContainer/elements/Liveclock";
import {useSelector} from "react-redux";

function Dashboard() {

    const [sessionStorage,setStorage]=useState();
    const isLoggedIn = useSelector((state)=> state.userreducer.isLoggedIn);
    console.log("loged :"+ isLoggedIn);
    if (!isLoggedIn) {
        //navigate("/admin");
        window.location.href ="/admin";
    }

    /*if(!isLoggedIn){
        return <div className="flex items-center justify-center h-screen">
            <p className="text-xl font-serif font-bold text-custom-green">Please log in to access the dashboard.</p>
        </div>
    }*/

    useEffect(() => {
        const links = document.querySelectorAll(".sidebar-link");

        const onClick = (e) => {
            e.preventDefault();
            links.forEach((l) => l.classList.remove("active"));
            e.currentTarget.classList.add("active");
        };

        links.forEach((link) => link.addEventListener("click", onClick));
        return () => links.forEach((link) => link.removeEventListener("click", onClick));
    }, []);

    return (
        <div id="admin-layout" className="flex min-h-screen">

<AdminH/>
            <main id="main-content" className="main-content flex-1">
                <header id="admin-header" className="bg-white shadow-sm border-b px-8 py-4">
                    <div className="flex justify-between items-center">
                        <div>
                            <h1 className="text-2xl font-serif font-bold text-custom-green">
                                Dashboard
                            </h1>
                            <p className="text-gray-600">
                                Welcome back, here's what's happening with your store
                            </p>
                        </div>
                        <div className="flex items-center space-x-4">
                            <div className="flex items-center space-x-2 text-sm text-gray-600">
                                <i className="fa-solid fa-calendar"></i>
                                <span>Today: {<LiveClock />}</span>
                            </div>
                        </div>
                    </div>
                </header>
                <Outlet/>
            </main>
        </div>
    );
}

export default Dashboard;